export const sizes = {
  xs: {
    size: 8,
  },
  sm: {
    size: 16,
  },
  md: {
    size: 24,
  },
  lg: {
    size: 32,
  },
  xl: {
    size: 48,
  },
  xxl: {
    size: 64,
  },
  full: {
    size: '100%',
  },
};

export type IconSize = keyof typeof sizes;

export type IconName =
  | 'logo'
  | 'logoShort'
  | 'logoWhite'
  | 'arrowDown'
  | 'arrowDowns'
  | 'arrowRight'
  | 'chevronLeft'
  | 'chevronRight'
  | 'chevronDown'
  | 'chevronUp'
  | 'facebook'
  | 'instagram'
  | 'twitter'
  | 'youtube'
  | 'linkedin'
  | 'whatsapp'
  | 'location'
  | 'locationSimple'
  | 'belief'
  | 'book'
  | 'qa'
  | 'video'
  | 'alarm'
  | 'clock'
  | 'close'
  | 'closeX'
  | 'envelope'
  | 'event'
  | 'headset'
  | 'lines'
  | 'phone'
  | 'play'
  | 'playCircle'
  | 'playFill'
  | 'search'
  | 'swipe'
  | 'tableOfContents'
  | 'telephone'
  | 'voice'
  | 'pdf';

export interface IconProps {
  iconName: IconName;
  size?: IconSize;
  iconColor?: string;
}
